import { ErrorProps } from '../components/Error';
import { GeneralSystemErrorIllustration, OktaCallbackErrorIllustration } from '../icons';
import { ErrorType } from '../view/ErrorPage';

const SYSTEM_ERROR_HEADER = 'Oops, something went wrong';
const SYSTEM_ERROR_BODY = "Sorry, we couldn't find the page you were looking for.";
const SYSTEM_ERROR_RETURN_BTN_TEXT = 'Return to overview';

//Function to return props for the error component
export const getErrorProps = (errorType: string, returnLink: string, handleBtnClick: () => void): ErrorProps => {
  let errorPageProps: ErrorProps;

  switch (errorType) {
    case ErrorType.GeneralSystemError:
    case ErrorType.AccountSelectionError:
      errorPageProps = {
        desktopIcon: GeneralSystemErrorIllustration,
        mobileIcon: GeneralSystemErrorIllustration,
        header: SYSTEM_ERROR_HEADER,
        bodyText: SYSTEM_ERROR_BODY,
        showButton: returnLink !== null,
        buttonText: SYSTEM_ERROR_RETURN_BTN_TEXT,
        buttonOnClick: handleBtnClick,
        errorType: errorType
      };
      break;
    case ErrorType.OktaCallbackTimezoneError:
      errorPageProps = {
        desktopIcon: OktaCallbackErrorIllustration,
        mobileIcon: OktaCallbackErrorIllustration,
        header: 'Device time out of sync',
        bodyText:
          'Please sync your device to the current date and time of your location to securely access your MyAccount portal',
        showButton: returnLink !== null,
        buttonText: 'Return to login',
        buttonOnClick: handleBtnClick,
        errorType: errorType
      };
      break;
    case ErrorType.OktaCallbackGenericError:
      errorPageProps = {
        desktopIcon: OktaCallbackErrorIllustration,
        mobileIcon: OktaCallbackErrorIllustration,
        header: 'Device time out of sync',
        bodyText:
          'Please sync your device to the current date and time of your location to securely access your MyAccount portal',
        showButton: returnLink !== null,
        buttonText: 'Return to login',
        buttonOnClick: handleBtnClick,
        errorType: errorType
      };
      break;
    default:
      errorPageProps = {
        desktopIcon: GeneralSystemErrorIllustration,
        mobileIcon: GeneralSystemErrorIllustration,
        header: SYSTEM_ERROR_HEADER,
        bodyText: SYSTEM_ERROR_BODY,
        showButton: true,
        buttonText: SYSTEM_ERROR_RETURN_BTN_TEXT,
        buttonOnClick: handleBtnClick,
        errorType: ErrorType.PageNotFound
      };
      break;
  }
  return errorPageProps;
};
